import React, { useEffect, useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { useParams } from 'react-router-dom';
import uploadDocumentToCar from '../../api/cars/uploadDocumentToCar';
import getCarDocuments from '../../api/cars/getCarDocuments';
import { CAR_DOCUMENT_TYPES } from '../../constants';

import HookForm from '../../components/HookForm/HookForm';
import SelectCarDocumentType from '../../components/Selects/SelectCarDocumentType';
import DocsInputNew from '../../components/Inputs/DocsInput/DocsInputNew';
import DeleteButton from '../../components/DeleteButton/DeleteButton';
import AddButton from '../../components/AddButton/AddButton';
import LoaderInline from '../../components/Loader/LoaderInline';
import Button from '../../components/Button/Button';
import EmptyData from '../../components/EmptyData/EmptyData';
import icon from '../../brand/generated/buttonIcons/addDeal.svg';
import { colors } from '../../constants/colors';

const formStyles = {
  document: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr 1fr 1fr 44px`, alignItems: 'end' },
};

const CAR_DOCUMENTS_COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id',
    width: '4%',
  },
  {
    Header: 'Тип документа',
    accessor: (row) => {
      const docType = CAR_DOCUMENT_TYPES.find((doc) => doc.value === row.typeId);
      return docType?.label || 'Неизвестный тип';
    },
    width: '30%',
  },
  {
    Header: 'Название документа',
    accessor: 'name',
    width: '30%',
  },
  {
    Header: 'Файл',
    accessor: (row) => (
      <a href={row.url} target="_blank" rel="noreferrer" style={{ color: colors.cameo }}>
        Скачать
      </a>
    ),
    width: '30%',
  },
  {
    Header: '',
    accessor: 'dots',
    width: '6%',
  },
];

const CarDocs = () => {
  const { id } = useParams();
  const row = () => [
    { component: SelectCarDocumentType, name: 'typeId' },
    { name: 'name', label: 'Название документа', placeholder: 'Например, "Договор купли-продажи Бекпулатов"' },
    {
      component: DocsInputNew,
      name: 'file',
      label: 'Файл документа',
      text: 'Файл документа',
      id: Math.random(),
    },
    {
      component: DeleteButton,
      name: 'delete',
      onClick: (e, index) => {
        removeRow(e, index);
      },
    },
  ];
  const [form, setForm] = useState([row()]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const table = useTable(
    {
      columns: CAR_DOCUMENTS_COLUMNS,
      data: documents,
      initialState: { pageIndex: 0, pageSize: 1000000 },
    },
    usePagination
  );

  const init = async () => {
    setLoading(true);
    const array = [];
    await getCarDocuments({ carId: id }).then((res) => {
      if (res.data) {
        res.data.forEach((item) => {
          array.push({
            id: item.id,
            typeId: item.typeId,
            name: item.name,
            url: item.url,
          });
        });
      }
    });
    setDocuments([...array]);
    setLoading(false);
  };

  const addRow = () => {
    setForm([...form, row()]);
  };

  const removeRow = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const newForm = form;
    newForm.slice(index, 1);
    setForm(newForm);
  };

  const onSubmit = () => {
    setLoading(true);
    const fields = form.map((i) => i.map((i) => i.value?.value || i.value));
    Promise.all(
      fields.map((field) =>
        uploadDocumentToCar({
          carId: id,
          typeId: field[0],
          name: field[1],
          file: field[2],
        })
      )
    ).finally(() => {
      init();
    });
  };

  useEffect(() => {
    init();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
        <LoaderInline />
      </div>
    );
  }

  return (
    <div
      style={{ padding: '0 20px 20px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}
    >
      <EmptyData
        title={`Документы автомобиля (${documents.length})`}
        subtitle={'Документы не найдены'}
        action={null}
        icon={icon}
        table={table}
        data={documents}
      />

      {form.map((row, index) => (
        <HookForm grid={formStyles.document} inputs={row} style={{ margin: 0 }} index={index} />
      ))}

      <div style={{ marginTop: -30, paddingLeft: 20 }}>
        <AddButton text="Добавить еще документ" onClick={addRow} />
        <div
          style={{
            marginTop: 20,
          }}
        >
          <Button text="Сохранить" fill onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};

export default CarDocs;
